<div class="et-recorder-wrapper-2" *ngIf="etSRService.enabled">

  <div class="placeholder-background" *ngIf="showBackground"></div>

  <div id="EtRecorderCanvas" class="recorder-background" *ngIf="isPencil"></div>

  <div class="upload-overlay" *ngIf="isUploading" aria-live="polite">
    <div class="upload-overlay-card">
      <ion-spinner name="crescent"></ion-spinner>
      <p class="upload-overlay-message">{{ uploadStatusMessage }}</p>
      <div class="upload-overlay-bar" *ngIf="uploadProgressPercent > 0">
        <div class="upload-overlay-bar-fill" [style.width.%]="uploadProgressPercent"></div>
      </div>
    </div>
  </div>

  <!-- Recording Mode -->
  <div *ngIf="!isConfirm">
    <video #outputVideo class="displayNone"></video>
    <video #cameraVideo autoplay [enabled]="!showBackground" appFreeDraggable [class.expanded]="showBackground" [class.displayNone]="!isCamera"></video>
  
    <div id="EtRecorderCanvas" class="recorder-background" *ngIf="isPencil"></div>
    <div
      class="actions-dock"
      *ngIf="!isUploading"
      [class.actions-dock--sharing]="screenStream"
      [class.actions-dock--expanded]="sharingActionsExpanded || dockPointerDown"
      (mouseenter)="onSharingDockEnter()"
      (mouseleave)="onSharingDockLeave()"
      (mousedown)="onDockPointerDown()"
      appFreeDraggable
      [enabled]="!showBackground && (!screenStream || sharingActionsExpanded)">
      <button
        type="button"
        class="sharing-indicator"
        *ngIf="screenStream"
        (click)="toggleSharingActions($event)">
        <span class="recording-dot" *ngIf="isStarted" [class.recording-dot--paused]="isPaused"></span>
        <span class="sharing-indicator-time" *ngIf="isStarted">{{ recordingTimeLabel }}</span>
        <ion-icon name="desktop-outline"></ion-icon>
        <span>{{ 'general.sharingScreen' | translate }}</span>
      </button>
      <div
        class="actions"
        [class.actions-initial]="showBackground">
      <div class="handle">
        <ion-icon color="gray" name="move-outline"></ion-icon>
      </div>
      <div class="recording-timer" *ngIf="isStarted" aria-live="polite">
        <span class="recording-dot" [class.recording-dot--paused]="isPaused"></span>
        <p class="recording-time">{{ recordingTimeLabel }}</p>
      </div>
      <ion-button color="primary" size="small" [fill]="isPencil? 'solid' : 'clear'" (click)="togglePencil()"  [matTooltip]="'general.pencilTool' | translate" matTooltipPosition="above">
        <div>
          <ion-icon name="create-outline"></ion-icon>
          <p>{{ 'general.pencil' | translate }}</p>
        </div>
      </ion-button>
      <ion-button color="primary" size="small" fill="clear" (click)="enableCamera()" *ngIf="!isCamera"  [matTooltip]="'general.enableCamera' | translate" matTooltipPosition="above">
        <div>
          <ion-icon name="camera-outline"></ion-icon>
          <p>{{ 'general.camera' | translate }}</p>
        </div>
      </ion-button>
      <ion-button color="primary" size="small" fill="solid" (click)="disableCamera()" *ngIf="isCamera"  [matTooltip]="'general.disableCamera' | translate" matTooltipPosition="above">
        <div>
          <ion-icon name="camera-outline"></ion-icon>
          <p>{{ 'general.camera' | translate }}</p>
        </div>
      </ion-button>
      <ion-button color="primary" size="small" fill="clear" (click)="enableScreenShare()" *ngIf="!screenStream"  [matTooltip]="'general.shareScreen' | translate" matTooltipPosition="above">
        <div>
          <ion-icon name="albums-outline"></ion-icon>
          <p>{{ 'general.screen' | translate }}</p>
        </div>
      </ion-button>
      <ion-button color="primary" size="small"  fill="solid" (click)="disableScreenShare()"  *ngIf="screenStream"  [matTooltip]="'general.shareScreen' | translate" matTooltipPosition="above">
        <div>
          <ion-icon name="albums-outline"></ion-icon>
          <p>{{ 'general.screen' | translate }}</p>
        </div>
      </ion-button>
      <ion-button color="primary" size="small" fill="clear" (click)="startRecording()" [matTooltip]="'general.startRecording' | translate" matTooltipPosition="above" *ngIf="!isStarted">
        <div>
          <ion-icon name="ellipse-outline"></ion-icon>
          <p>{{ 'general.record' | translate }}</p>
        </div>
      </ion-button>
      <ion-button color="primary" size="small" fill="clear" [matTooltip]="'general.pauseRecording' | translate" (click)="pauseRecording()" matTooltipPosition="above" *ngIf="isStarted && !isPaused">
        <div>
          <ion-icon name="pause-outline"></ion-icon>
          <p>{{ 'general.pause' | translate }}</p>
        </div>
      </ion-button>
      <ion-button color="primary" size="small" fill="clear" [matTooltip]="'general.resumeRecording' | translate" (click)="resumeRecording()" matTooltipPosition="above" *ngIf="isStarted && isPaused">
        <div>
          <ion-icon name="play-outline"></ion-icon>
          <p>{{ 'general.resume' | translate }}</p>
        </div>
      </ion-button>
      <ion-button color="primary" size="small" fill="solid" (click)="saveRecording()" [matTooltip]="'general.doneRecording' | translate" matTooltipPosition="above" *ngIf="isStarted">
        <div>
          <ion-icon name="stop-outline"></ion-icon>
          <p>{{ 'general.done' | translate }}</p>
        </div>
      </ion-button>
      <ion-button color="primary" size="small" fill="clear" (click)="cancelRecording()" [matTooltip]="'general.cancel' | translate" matTooltipPosition="above">
        <div>
          <ion-icon name="close-outline"></ion-icon>
          <p>{{ 'general.cancel' | translate }}</p>
        </div>
      </ion-button>
    </div>
    </div>
  </div>
  
  <!-- Feedback Mode -->
  <div class="confirm" *ngIf="isConfirm">

    <video #cameraVideo autoplay [class.expanded]="showBackground" [src]="recordedVideo.url" controls></video>

    <div class="actions actions-confirm">
      <ion-button color="danger" (click)="cancelRecording()">
        {{ 'general.cancel' | translate }}
      </ion-button>
      <ion-button color="success" (click)="approveRecording()">
        {{ 'general.approve' | translate }}
      </ion-button>
    </div>
  </div>
</div>
